import { Plus } from 'lucide-react';
import { Button, Card, Typography } from '../ui';
import { useTranslation } from '../../../lib/i18n';
import styles from './GroupsEmpty.module.css';

// The zero-groups state — Figma 11105-126483: a tall sunken card holding the
// stacked-cards mark, "No groups yet", and the New-group CTA. The mark is bespoke
// illustration (a group-chat glyph drawn from three offset cards), not an icon, so
// it is hand-drawn rather than taken from lucide.
function StackedGroupsMark() {
  return (
    <svg width="129" height="56" viewBox="0 0 129 56" fill="none" aria-hidden className={styles.mark}>
      <rect x="13.5" y="0.5" width="101" height="49" rx="8" className={styles.markBack} />
      <rect x="7" y="8" width="115" height="47" rx="9" className={styles.markMid} />
      <rect x="0.5" y="17.5" width="128" height="38" rx="9" className={styles.markFront} />
      <circle cx="21" cy="37" r="7" className={styles.markDot} />
      <rect x="38" y="33" width="79" height="3" rx="1.5" className={styles.markLine} />
      <rect x="38" y="39" width="63" height="3" rx="1.5" className={styles.markLine} />
    </svg>
  );
}

export function GroupsEmpty({ onNewGroup, disabled }: { onNewGroup: () => void; disabled?: boolean }) {
  const { t } = useTranslation();
  return (
    <Card disablePadding size="sm" className={styles.card}>
      <div className={styles.figure}>
        <StackedGroupsMark />
        <Typography variant="h4" color="secondary" align="center">
          {t('settings.whatsapp.groups.empty')}
        </Typography>
      </div>
      <Button variant="outlined" color="standard" startIcon={<Plus size={16} aria-hidden />} onClick={onNewGroup} disabled={disabled}>
        {t('settings.whatsapp.newGroup')}
      </Button>
    </Card>
  );
}
